import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

export const ImageZoomFull = ({
    imageUrl,
    alt = 'Imagen ampliable',
    className = '',
}) => (
    <Zoom>
        <img
            alt={alt}
            src={imageUrl}
            width={1200}
            height={800}
            loading="lazy"
            decoding="async"
            className={className || 'rounded-lg w-full h-auto'}
        />
    </Zoom>
);
